<template>
  <div class="step-pass-type">
    <transition-group
      name="pass-slide-down"
      tag="div"
      class="pass-types"
    >
      <PassType
        v-for="pass in passTypes"
        :key="pass.id"
        :pass="pass.id"
      />
    </transition-group>
    <p class="step-pass-type__message">
      All passes start after you take your first trip.
    </p>
    <DiscountBanner
      v-if="hasDiscountedPasses"
      :show-discount-passes="showDiscountPasses"
      :showing-passes-below="showDiscountedPassesBelow"
      @toggle="toggleDiscountedPasses"
    />
    <transition-group
      v-if="showDiscountedPassesBelow"
      name="pass-slide-down"
      tag="div"
      class="pass-types"
    >
      <template v-if="showDiscountPasses">
        <PassType
          v-for="pass in discountedPassTypes"
          :key="pass.id"
          :pass="pass.id"
        />
      </template>
    </transition-group>
    <PassFeesBanner
      :show-discount="showDiscountPasses"
      :show-discount-below="showDiscountedPassesBelow"
    />
    <IndegoPricingBanner />
  </div>
</template>
<script>
import PassType from '../components/PassType.vue';
import DiscountBanner from '../components/DiscountBanner.vue';
import PassFeesBanner from '../components/PassFeesBanner.vue';
import IndegoPricingBanner from '../components/system-specific/IndegoPricingBanner.vue';
import store from '../store';

export default {
  components: {
    PassType, DiscountBanner, PassFeesBanner, IndegoPricingBanner,
  },
  props: {
    discount: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      showDiscountPasses: this.discount,
      showDiscountedPassesBelow: false,
      discountTypes: ['nevada_rf', 'access', 'metro_rf'],
    };
  },
  computed: {
    systemId() {
      return this.$store.state.systemId;
    },
    hasDiscountedPasses() {
      return this.discountedPassTypes.length > 0;
    },
    passTypes() {
      if (!this.showDiscountedPassesBelow && this.showDiscountPasses) {
        return this.discountedPassTypes;
      }
      return this.$store.state.passTypes.filter(type => ('discountVerification' in type) === false).filter(type => !(type.visible === false));
    },
    discountedPassTypes() {
      return this.$store.state.passTypes.filter(type => ('discountVerification' in type) === true).filter(type => !(type.visible === false));
    },
  },
  methods: {
    toggleDiscountedPasses() {
      // on mobile, just append the access passes to the bottom of the page
      // on desktop, toggle the passes shown above
      this.showDiscountedPassesBelow = window.innerWidth < 720;
      this.showDiscountPasses = !this.showDiscountPasses;
    },
  },
  beforeRouteEnter(to, from, next) {
    if (store.state.passTypes.length === 1) {
      const passType = store.state.passTypes[0];
      store.dispatch('updatePass', passType.id);
      next({ name: store.getters.nextStep('pass') });
      return;
    }
    next();
  },
};
</script>
